import React, { useEffect, useRef, useState } from 'react';
import { Toaster } from "react-hot-toast";
import MapCenterModal from '../components/modals/MapCenterModal';
import BarraTrafico from './BarraTrafico';
import '../Pages/Css/traficoResponsive.css';

const Geocercas2 = () => {
    const [contracts] = useState([]);
    const mapCenterModalRef = useRef(null);

    useEffect(() => {
        document.body.classList.add('map-center-responsive-page');
        return () => document.body.classList.remove('map-center-responsive-page');
    }, []);

    const toggleNavigationMenu = () => {
        document.querySelector('[class*="sidenav-toggle"]')?.click();
    };

    const voidFuncion = () => { };

    const handleLiveNow = (msg) => {
        mapCenterModalRef.current?.handleLiveNow?.(msg);
    };

    const handleLiveEnded = (msg) => {
        mapCenterModalRef.current?.handleLiveEnded?.(msg);
    };

    return (
        <div className="layout-wrapper layout-content-navbar trafico-page map-center-page">
            <div className="layout-container">
                <div className="layout-page">
                    <BarraTrafico
                        count={contracts?.length}
                        filteredSolicitudes={contracts}
                        onUpdateSolicitudes={voidFuncion}
                        ListarContratos={voidFuncion}
                        differTime={voidFuncion}
                        onLiveNow={handleLiveNow}
                        onLiveEnded={handleLiveEnded}
                        onToggleNavigation={toggleNavigationMenu}
                    />
                    <Toaster position="bottom-right" />
                    <MapCenterModal
                        ref={mapCenterModalRef}
                        appName="GEOCERCAS2"
                        appMode="geocercas-only"
                    />
                </div>
            </div>
        </div>
    );
};

export default Geocercas2;
